import { Box, Tooltip, Typography, useTheme } from '@mui/material';
import Divider from 'components/divider';
import { InfoIcon } from 'lucide-react';
import { FormattedNumber, useIntl } from 'react-intl';
import { Feeds } from 'views/bluviu-nutrition/features/scenarios/types/scenario-result.type';

type ToolTipProps = {
  feedSummary: Feeds[];
  feedPlan: string;
  display: 'icon' | 'text' | 'both';
};

const PAGE_NAME_ID = 'bluViuNutrition.viewScenarioResultGt2';

const ScenarioFeedsTooltip: React.FC<ToolTipProps> = ({ feedPlan, feedSummary, display }) => {
  const intl = useIntl();
  const theme = useTheme();

  return (
    <Tooltip
      placement={'top'}
      title={
        <Box display={'flex'} flexDirection={'column'} gap={2}>
          <Box display={'flex'} gap={1}>
            <Typography fontWeight={'bold'}>{intl.formatMessage({ id: `${PAGE_NAME_ID}.tooltip.tooltipContent` })} -</Typography>
            <Typography>{feedPlan}</Typography>
          </Box>
          <Divider color={theme.palette.darkBlue.o50} />
          <Box display={'flex'} flexDirection={'column'} gap={1}>
            <Typography>{intl.formatMessage({ id: `${PAGE_NAME_ID}.tooltip.feedsInProgram` })}</Typography>
            {feedSummary &&
              feedSummary.map((feed, key) => {
                return (
                  <Box key={key} display={'flex'} justifyContent={'space-between'}>
                    <Typography fontWeight={'bold'} lineHeight={2}>
                      {<FormattedNumber value={feed.fishSizeStart} />}g
                    </Typography>
                    <Typography lineHeight={2}>{feed.feedName}</Typography>
                  </Box>
                );
              })}
          </Box>
        </Box>
      }>
      <Box
        gap={4}
        minWidth={0}
        display={'flex'}
        overflow={'hidden'}
        flexDirection={'row'}
        alignItems={'center'}
        justifyContent={'flex-start'}>
        {display !== 'icon' && <Typography noWrap>{feedPlan}</Typography>}
        {display !== 'text' && <InfoIcon size={16} strokeWidth={3} style={{ flexShrink: 0 }} />}
      </Box>
    </Tooltip>
  );
};

export default ScenarioFeedsTooltip;
